import { SharedModule } from '../../shared/shared.module';
import { InvoicesComponent } from './invoices.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceListModule } from './invoice-list/invoice-list.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    SharedModule,
    RouterModule,
    InvoiceListModule
  ],
  declarations: [InvoicesComponent],
  exports: [InvoicesComponent],
  entryComponents: []
})
export class InvoicesModule { }
